import { render, staticRenderFns } from "./commonMixin.vue?vue&type=template&id=2b792e55"
import script from "./commonMixin.vue?vue&type=script&lang=js"
export * from "./commonMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports